import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSetupProjectIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5298 6.353L9.52981 6.353M9.52981 6.353C9.52981 5.18346 8.58171 4.23535 7.41217 4.23535C6.24262 4.23535 5.29452 5.18346 5.29452 6.353M9.52981 6.353C9.52981 7.52254 8.58171 8.47065 7.41217 8.47065C6.24262 8.47065 5.29452 7.52254 5.29452 6.353M5.29452 6.353L2.64746 6.353M18.5298 14.8236L15.8828 14.8236M15.8828 14.8236C15.8828 13.654 14.9347 12.7059 13.7651 12.7059C12.5956 12.7059 11.6475 13.654 11.6475 14.8236M15.8828 14.8236C15.8828 15.9931 14.9347 16.9412 13.7651 16.9412C12.5956 16.9412 11.6475 15.9931 11.6475 14.8236M11.6475 14.8236L2.64746 14.8236",
		stroke: "#B3EC49",
		strokeWidth: 1.41176
	})
});
export default SvgSetupProjectIcon;
